import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  archiveDisplayTitle,
} from './homeworkUtils'

export default function SubmitPanel({
  homework,
  archivesList = [],
  archivesLoading = false,
  archivesError = '',
  onRetryArchives,
  draft = {},
  onDraftChange,
  onSubmit,
  submitting = false,
  mode = 'submit', // submit | replace
}) {
  const { t } = useTranslation()
  const [keyword, setKeyword] = useState('')
  const [confirmOpen, setConfirmOpen] = useState(false)

  const selectedArchiveId = draft.archiveId || ''
  const message = draft.message || ''

  const filtered = useMemo(() => {
    const kw = keyword.trim().toLowerCase()
    return (archivesList || [])
      .filter((archive) => {
        if (!kw) return true
        const title = archiveDisplayTitle(archive, t).toLowerCase()
        const flow = String(archive.workflowName || '').toLowerCase()
        return title.includes(kw) || flow.includes(kw)
      })
      .sort((a, b) => String(b.updatedAt || '').localeCompare(String(a.updatedAt || '')))
  }, [archivesList, keyword, t])

  const selected = (archivesList || []).find((a) => a.archiveId === selectedArchiveId)
  const selectedTitle = selected ? archiveDisplayTitle(selected, t) : ''

  return (
    <div>
      <div className="hwb-submit-tools">
        <input
          className="hwb-search"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="搜索全部存档名称或流程"
        />
      </div>

      <div className="hwb-archive-list">
        {archivesLoading ? (
          <div className="hwb-empty" style={{ padding: 24 }}>
            正在加载存档…
          </div>
        ) : archivesError ? (
          <div className="hwb-empty" style={{ padding: 24 }}>
            <div>存档加载失败：{archivesError}</div>
            <button type="button" className="hwb-btn hwb-btn-secondary" style={{ marginTop: 12 }} onClick={onRetryArchives}>
              重试
            </button>
          </div>
        ) : filtered.length === 0 ? (
          <div className="hwb-empty" style={{ padding: 24 }}>
            {archivesList?.length ? '没有匹配的存档，请调整搜索条件' : t('hw_no_archives')}
          </div>
        ) : (
          filtered.map((archive) => {
            const selected = archive.archiveId === selectedArchiveId
            const isCurrent = homework?.archiveId === archive.archiveId
            return (
              <button
                key={archive.archiveId}
                type="button"
                className={`hwb-archive-item${selected ? ' is-selected' : ''}${isCurrent ? ' is-current' : ''}`}
                onClick={() => onDraftChange?.({ ...draft, archiveId: archive.archiveId })}
              >
                <div>
                  <p className="hwb-archive-title">{archiveDisplayTitle(archive, t)}</p>
                  <div className="hwb-archive-meta">
                    {archive.workflowName || t('hw_unnamed_flow')} · {archive.updatedAt || '-'}
                    {isCurrent ? ' · 当前已提交' : ''}
                  </div>
                </div>
                <span className="hwb-badge">{selected ? '已选' : '选择'}</span>
              </button>
            )
          })
        )}
      </div>

      <label className="hwb-section-title" htmlFor={`hwb-msg-${homework?.id}`}>
        提交说明（选填）
      </label>
      <textarea
        id={`hwb-msg-${homework?.id}`}
        className="hwb-textarea"
        rows={2}
        value={message}
        onChange={(e) => onDraftChange?.({ ...draft, message: e.target.value })}
        placeholder={t('hw_message_placeholder')}
      />

      <div className="hwb-submit-bar">
        <div className="hwb-submit-selected">
          {selectedTitle
            ? <>已选：<strong>{selectedTitle}</strong></>
            : '请先选择一份训练存档'}
        </div>
        <button
          type="button"
          className="hwb-btn hwb-btn-primary"
          disabled={!selectedArchiveId || submitting}
          onClick={() => setConfirmOpen(true)}
        >
          {submitting ? '提交中…' : (mode === 'replace' ? '确认更换提交' : '提交作业')}
        </button>
      </div>

      {confirmOpen ? (
        <div className="hwb-confirm-mask" role="presentation" onClick={() => setConfirmOpen(false)}>
          <div className="hwb-confirm" role="dialog" aria-label="确认提交" onClick={(e) => e.stopPropagation()}>
            <h4>{mode === 'replace' ? '确认更换提交？' : '确认提交这份作业？'}</h4>
            <p>
              将提交存档《{selectedTitle}》。提交后仍可更换。
            </p>
            <div className="hwb-confirm-actions">
              <button type="button" className="hwb-btn hwb-btn-secondary" onClick={() => setConfirmOpen(false)}>
                取消
              </button>
              <button
                type="button"
                className="hwb-btn hwb-btn-ok"
                disabled={submitting}
                onClick={async () => {
                  const ok = await onSubmit?.(selectedArchiveId, message)
                  if (ok !== false) setConfirmOpen(false)
                }}
              >
                {submitting ? '提交中…' : '确认提交'}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}
